/**
 * Translated Return Policy body.
 * Mirrors the English CMS HTML for page_id "return-policy".
 */

const frenchReturns = `
<div class="legal-page container">
      <h1>Politique de retours et d'échanges</h1>
      <p class="last-updated"><em>Dernière mise à jour : octobre 2025</em></p>

      <p class="intro-text">
        Chez Cranford Publications, nous voulons que vous soyez pleinement satisfait de votre achat. Si, pour quelque raison que ce soit, votre commande ne vous convient pas, nous sommes là pour vous aider.
      </p>

      <h2>✅ Admissibilité au retour</h2>
      <p>Pour être admissible à un retour, l'article doit respecter les conditions suivantes :</p>
      <div class="highlight-box">
        <ul>
          <li>Retourné dans les <strong>30 jours</strong> suivant la date d'achat</li>
          <li>Dans son état d'origine, non ouvert</li>
          <li>Sans écriture, marques ni dommages</li>
          <li>Emballage d'origine intact</li>
        </ul>
      </div>

      <h2>❌ Articles non retournables</h2>
      <p>Les articles suivants ne peuvent pas être retournés :</p>
      <div class="info-box">
        <ul>
          <li>Téléchargements numériques et produits en continu</li>
          <li>Articles ouverts ou utilisés</li>
          <li>Articles endommagés par une mauvaise manipulation du client</li>
          <li>Commandes personnalisées</li>
        </ul>
      </div>

      <h2>📦 Comment retourner un article</h2>
      <ol>
        <li><strong>Communiquez d'abord avec nous :</strong> écrivez à orders@cranfordpub.com ou composez le 1-902-929-2391 en indiquant les détails de votre commande et le motif du retour</li>
        <li><strong>Obtenez une autorisation :</strong> nous vous enverrons les consignes de retour et un numéro d'autorisation</li>
        <li><strong>Emballez soigneusement :</strong> protégez les livres pour éviter les dommages pendant le transport</li>
        <li><strong>Renvoyez l'article :</strong> expédiez-le à :<br>
            <div class="info-note">
              <strong>Cranford Publications</strong><br>
              44549 Cabot Trail, RR#1<br>
              Englishtown, Cape Breton Island<br>
              Nouvelle-Écosse, Canada B0C 1H0
            </div>
        </li>
        <li><strong>Traitement du remboursement :</strong> dès réception et inspection, nous traiterons votre remboursement dans un délai de 5 à 7 jours ouvrables</li>
      </ol>

      <h2>💰 Mode de remboursement</h2>
      <p>
        Le remboursement est versé selon le mode de paiement d'origine. Prévoyez 5 à 10 jours ouvrables après le traitement pour que le montant apparaisse dans votre compte.
      </p>
      <div class="info-note">
        <strong>Note :</strong> les frais d'expédition d'origine ne sont pas remboursables, sauf si le retour est dû à notre erreur.
      </div>

      <h2>🚚 Frais de retour</h2>
      <p>
        Vous assumez les frais d'expédition du retour, sauf si le retour est dû à notre erreur ou à un produit défectueux. Les frais d'expédition ne sont pas remboursables.
      </p>

      <h2>🔄 Échanges</h2>
      <p>
        Nous remplaçons uniquement les articles défectueux ou endommagés à l'arrivée. Si vous devez échanger un article contre le même produit, communiquez avec nous dès que possible.
      </p>

      <h2>⚠️ Articles endommagés ou défectueux</h2>
      <div class="highlight-box">
        <p><strong>Si vous recevez un article endommagé ou défectueux :</strong></p>
        <ul>
          <li>Communiquez avec nous immédiatement en joignant des photos des dommages</li>
          <li>Nous organiserons un remplacement ou un remboursement complet</li>
          <li>Nous assumerons les frais de retour</li>
        </ul>
      </div>

      <h2>🕐 Remboursement en retard ou manquant</h2>
      <p>Si vous n'avez pas reçu votre remboursement dans le délai prévu :</p>
      <ul>
        <li>Vérifiez de nouveau votre compte bancaire</li>
        <li>Communiquez avec l'émetteur de votre carte (l'affichage officiel peut prendre du temps)</li>
        <li>Communiquez avec votre banque (les délais de traitement varient)</li>
        <li>Si, après cela, le remboursement n'apparaît toujours pas, écrivez-nous</li>
      </ul>
    </div>
`;

const germanReturns = `
<div class="legal-page container">
      <h1>Rückgabe- und Umtauschrichtlinie</h1>
      <p class="last-updated"><em>Zuletzt aktualisiert: Oktober 2025</em></p>

      <p class="intro-text">
        Bei Cranford Publications möchten wir, dass Sie mit Ihrem Kauf vollständig zufrieden sind. Wenn Ihre Bestellung aus irgendeinem Grund nicht passt, helfen wir gerne.
      </p>

      <h2>✅ Rückgabeberechtigung</h2>
      <p>Für eine Rückgabe müssen die Artikel folgende Bedingungen erfüllen:</p>
      <div class="highlight-box">
        <ul>
          <li>Rücksendung innerhalb von <strong>30 Tagen</strong> nach dem Kaufdatum</li>
          <li>Im Originalzustand, ungeöffnet</li>
          <li>Ohne Beschriftung, Markierungen oder Beschädigungen</li>
          <li>Originalverpackung unversehrt</li>
        </ul>
      </div>

      <h2>❌ Nicht rückgabefähige Artikel</h2>
      <p>Folgende Artikel können nicht zurückgegeben werden:</p>
      <div class="info-box">
        <ul>
          <li>Digitale Downloads und Streaming-Produkte</li>
          <li>Geöffnete oder benutzte Artikel</li>
          <li>Durch unsachgemäße Behandlung beschädigte Artikel</li>
          <li>Sonderanfertigungen oder personalisierte Bestellungen</li>
        </ul>
      </div>

      <h2>📦 So senden Sie einen Artikel zurück</h2>
      <ol>
        <li><strong>Zuerst Kontakt aufnehmen:</strong> Schreiben Sie an orders@cranfordpub.com oder rufen Sie 1-902-929-2391 an und nennen Sie Bestelldaten sowie den Rückgabegrund</li>
        <li><strong>Genehmigung erhalten:</strong> Wir senden Ihnen Rückgabehinweise und eine Autorisierungsnummer</li>
        <li><strong>Sicher verpacken:</strong> Bücher sorgfältig verpacken, damit sie beim Rückversand nicht beschädigt werden</li>
        <li><strong>Zurücksenden:</strong> Senden Sie die Artikel an:<br>
            <div class="info-note">
              <strong>Cranford Publications</strong><br>
              44549 Cabot Trail, RR#1<br>
              Englishtown, Cape Breton Island<br>
              Nova Scotia, Kanada B0C 1H0
            </div>
        </li>
        <li><strong>Erstattung:</strong> Nach Eingang und Prüfung erstatten wir innerhalb von 5–7 Werktagen</li>
      </ol>

      <h2>💰 Erstattungsmethode</h2>
      <p>
        Erstattungen erfolgen über die ursprüngliche Zahlungsmethode. Bitte rechnen Sie nach der Bearbeitung mit 5–10 Werktagen, bis der Betrag auf Ihrem Konto erscheint.
      </p>
      <div class="info-note">
        <strong>Hinweis:</strong> Ursprüngliche Versandkosten werden nicht erstattet, es sei denn, die Rückgabe liegt an unserem Fehler.
      </div>

      <h2>🚚 Rückversandkosten</h2>
      <p>
        Die Kosten für den Rückversand tragen Sie, es sei denn, die Rückgabe liegt an unserem Fehler oder einem defekten Produkt. Versandkosten sind nicht erstattungsfähig.
      </p>

      <h2>🔄 Umtausch</h2>
      <p>
        Wir ersetzen Artikel nur, wenn sie bei Ankunft defekt oder beschädigt sind. Wenn Sie einen Artikel gegen dasselbe Produkt tauschen möchten, kontaktieren Sie uns bitte so schnell wie möglich.
      </p>

      <h2>⚠️ Beschädigte oder defekte Artikel</h2>
      <div class="highlight-box">
        <p><strong>Wenn Sie einen beschädigten oder defekten Artikel erhalten:</strong></p>
        <ul>
          <li>Kontaktieren Sie uns sofort und senden Sie Fotos des Schadens</li>
          <li>Wir veranlassen Ersatz oder volle Erstattung</li>
          <li>Die Rückversandkosten übernehmen wir</li>
        </ul>
      </div>

      <h2>🕐 Verspätete oder fehlende Erstattung</h2>
      <p>Wenn Ihre Erstattung nicht im erwarteten Zeitraum erscheint:</p>
      <ul>
        <li>Prüfen Sie Ihr Bankkonto erneut</li>
        <li>Wenden Sie sich an Ihren Kreditkartenanbieter (die Buchung kann dauern)</li>
        <li>Wenden Sie sich an Ihre Bank (Bearbeitungszeiten variieren)</li>
        <li>Wenn danach immer noch nichts eingegangen ist, kontaktieren Sie uns</li>
      </ul>
    </div>
`;

export const RETURNS_PAGE_TRANSLATIONS = {
  'fr-CA': {
    title: "Politique de retours et d'échanges",
    description:
      'Notre politique de retours, de remboursement et d’échanges pour les livres et CD de Cranford Publications.',
    html: frenchReturns,
  },
  'fr-FR': {
    title: "Politique de retours et d'échanges",
    description:
      'Notre politique de retours, de remboursement et d’échanges pour les livres et CD de Cranford Publications.',
    html: frenchReturns,
  },
  de: {
    title: 'Rückgabe- und Umtauschrichtlinie',
    description:
      'Unsere Richtlinie für Rückgaben, Erstattungen und Umtausch bei Cranford Publications.',
    html: germanReturns,
  },
};
